export default {
  namespaced: true,
  security_self_audit: {
    title: "Security Self Audit",
    security_self_audits_title: "Security Self Audits",
    template: {
      title: "Form Templates",
      name: "Name",
      question: "Question",
      add_new_field: "Add a New Field",
      type_response: "Response Type",
      field_name: "Field Name",
      field_types: "Field Types",
      field_type_config: "Field Type Configuration",
      options: "Options",
      option_name: "Option Name",
      add_option: "Add an Option",
      added_options: "Added Options",
    },
    form_validations: {
      name: "Name is required",
      type: "Type is required",
    },
    form: {
      title: "Risk Form",
    },
    required: "Required",
    close: "Close",
    Apply: "Apply",
    comment: "Comment",
    file: "Files",
    select_template: "Select Template",
    select_reviewer: "Select reviewer",
    review_comments: "Review Comments",
    reference_number: "Reference Number",
    template_name: "Template Name",
    template_composed: "Composed",
    index: "Index",
    btn_start_form: "Start Form",
    btn_send_to_review: "Send to Review",
    btn_approve: "Approve",
    btn_reject: "Reject",
    btn_reassign: "Reassign",
    btn_add_comment: "Add Comment",
    add_comment_placeholder: "Add a comment...",
    states :
      {
        title: "State",
        created: "Created",
        in_progress: "In Progress",
        in_review: "In Review",
        approved: "Approved",
        not_approved: "Not Approved",
        reassigned : "Reassigned",
        reasigned : "Reassigned"
      },
    history: {
        title: "History",
        user: "User",
        date: "Date",
        entries: "entries",
        note: "Note",
        empty: "No history available",
        show_less: "Show less",
        show_all: "Show entire history",
      },
      fill_form: "Audit created. Fill the form now.",
      failed_create_audit: "Failed to create audit",
      answers_saved: "Answers saved",
      error_loading_audit: "Error loading Security Self Audit",
      status_updated: "Status updated to {newStatus}",
      failed_update_status: "Failed to update status",
      save_failed: "Could not save",
      save_timeout: "Save operation timed out. Please try again.",
      form_not_ready: "Form is not ready. Please wait and try again.",
      status: "Status",
      new_audit: "New audit"
  },
  confirm_cancel: "Are you sure you want to cancel this security self audit?",
  canceled: "Security self audit canceled",
};
